import { render, staticRenderFns } from "./iconMicrophone.vue?vue&type=template&id=6c9b0bec&scoped=true"
import script from "./iconMicrophone.vue?vue&type=script&lang=js"
export * from "./iconMicrophone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b0bec",
  null
  
)

export default component.exports